<template>
  <div>
    <div
      :class="{
        row: ![
          FORM_TYPE.ARRAY_OBJECT,
          FORM_TYPE.SLOT,
          FORM_TYPE.HEADER
        ].includes(rowInput[0].type)
      }"
      v-for="(rowInput, rowIndex) of listRowInput"
      :key="'row' + rowIndex"
    >
      <template v-for="(el, index) of rowInput">
        <template v-if="isItemShow(modelData, el)">
          <template v-if="el.type === FORM_TYPE.ARRAY_OBJECT">
            <template v-if="!isNaN(modelData[el.size])">
              <template v-for="childRowIndex in Number(modelData[el.size])">
                <FormGroupRowLayout
                  :key="'childRowIndex-' + childRowIndex"
                  :listFields="el.items"
                  :modelData="modelData[el.model][childRowIndex - 1]"
                  :submitClicked="submitClicked"
                />
              </template>
            </template>
          </template>
          <template v-else-if="el.type === FORM_TYPE.HEADER">
            <h3 :key="'header' + rowIndex + index" class="header-section">
              <hr v-if="!el.isFirst" />
              {{ el.label }}
            </h3>
          </template>
          <template v-else-if="el.type === FORM_TYPE.SLOT">
            <slot :name="el.name"></slot>
          </template>
          <template v-else>
            <TextAreaWithLabel
              v-if="el.type === FORM_TYPE.TEXTAREA"
              :key="'textarea' + rowIndex + index"
              :classList="getClassList(el.itemPerRow)"
              :label="el.label"
              :rows="el.rows"
              :maxLength="getMaxLength(el)"
              :description="el.description"
              :placeholder="el.placeholder"
              v-model="modelData[el.model]"
              :submitClicked="submitClicked"
              :isRequired="el.isRequired"
            />
            <CheckboxGroup
              v-else-if="el.type === FORM_TYPE.CHECKBOX"
              :key="'checkbox' + rowIndex + index"
              :classList="getClassList(el.itemPerRow)"
              :label="el.label"
              :name="el.model"
              :description="el.description"
              :optionList="el.optionList"
              v-model="modelData[el.model]"
              :submitClicked="submitClicked"
              :isRequired="el.isRequired"
            />
            <RadioGroup
              v-else-if="el.type === FORM_TYPE.RADIO"
              :key="'radio' + rowIndex + index"
              :classList="getClassList(el.itemPerRow)"
              :label="el.label"
              :name="el.model"
              :description="el.description"
              :optionList="el.optionList"
              :hasOther="el.hasOther"
              :initialSelection="el.initialSelection"
              :isBooleanModel="el.isBooleanModel"
              v-model="modelData[el.model]"
              :submitClicked="submitClicked"
              :isRequired="el.isRequired"
            />
            <DropdownWithLabel
              v-else-if="el.type === FORM_TYPE.DROPDOWN"
              :key="'dropdown' + rowIndex + index"
              :classList="getClassList(el.itemPerRow)"
              :label="el.label"
              :name="el.model"
              :optionList="el.optionList"
              v-model="modelData[el.model]"
              :submitClicked="submitClicked"
              :isRequired="el.isRequired"
            />
            <DatePickerWithLabel
              v-else-if="el.type === FORM_TYPE.DATEPICKER"
              :key="'datepicker' + rowIndex + index"
              :classList="getClassList(el.itemPerRow)"
              :label="el.label"
              :initialView="el.initialView"
              :allowPastDate="el.allowPastDate"
              v-model="modelData[el.model]"
              :submitClicked="submitClicked"
              :isRequired="el.isRequired"
            />
            <DayHoursSelector
              v-else-if="el.type === FORM_TYPE.DAY_HOURS_SELECTOR"
              :key="'day-hours-selector' + rowIndex + index"
              :classList="getClassList(el.itemPerRow)"
              :label="el.label"
              :listDays="el.listDays"
              v-model="modelData[el.model]"
              :submitClicked="submitClicked"
              :isRequired="el.isRequired"
            />
            <SalaryRange
              v-else-if="el.type === FORM_TYPE.SALARY_RANGE"
              :key="'salary-range' + rowIndex + index"
              :label="el.label"
              v-model="modelData[el.model]"
              :submitClicked="submitClicked"
              :isRequired="el.isRequired"
            />
            <TextBoxWithLabel
              v-else
              :key="'textbox' + rowIndex + index"
              :classList="getClassList(el.itemPerRow)"
              :label="el.label"
              :maxLength="getMaxLength(el)"
              :description="el.description"
              :type="el.inputType"
              :placeholder="el.placeholder"
              :validation="el.validation"
              v-model="modelData[el.model]"
              :submitClicked="submitClicked"
              :isRequired="el.isRequired"
            />
          </template>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
/* This component is used to show for a list of form (textbox, radio button, checkbox, datepicker ...) 
Each element of form group will be layout by each row, from top to bottom
*/
import { FORM_TYPE } from "../../constants/custom-define-type";
import TextBoxWithLabel from "./TextBoxWithLabel";
import TextAreaWithLabel from "./TextAreaWithLabel";
import DatePickerWithLabel from "./DatePickerWithLabel";
import RadioGroup from "./RadioGroup";
import DropdownWithLabel from "./DropdownWithLabel";
import CheckboxGroup from "./CheckboxGroup";
import DayHoursSelector from "./DayHoursSelector";
import SalaryRange from "./SalaryRange";
import { DATA_MODEL_MAX_LENGTH } from "../../constants/data-model-length";

export default {
  name: "FormGroupRowLayout",
  components: {
    TextBoxWithLabel,
    TextAreaWithLabel,
    DatePickerWithLabel,
    RadioGroup,
    DropdownWithLabel,
    CheckboxGroup,
    DayHoursSelector,
    SalaryRange
  },
  props: {
    listFields: {
      type: Array,
      default: () => []
    },
    modelData: Object,
    submitClicked: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      FORM_TYPE: FORM_TYPE
    };
  },
  computed: {
    listRowInput() {
      return this.listFields.reduce((accResult, cur) => {
        if (accResult.length === 0) {
          return [[cur]];
        }
        if (cur.itemPerRow == null || cur.itemPerRow === 1) {
          return [...accResult, [cur]];
        }
        const lastEl = accResult[accResult.length - 1];
        const numberOfitemPerRow = lastEl[0].itemPerRow
          ? lastEl[0].itemPerRow
          : 1;
        if (numberOfitemPerRow === lastEl.length) {
          return [...accResult, [cur]];
        }
        accResult[accResult.length - 1].push(cur);
        return accResult;
      }, []);
    }
  },
  methods: {
    getClassList(itemPerRow) {
      if (itemPerRow == null || itemPerRow === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / itemPerRow);
    },
    getMaxLength(el) {
      if (el.maxLength) {
        return el.maxLength;
      }
      if (Object.keys(DATA_MODEL_MAX_LENGTH).includes(el.model)) {
        return DATA_MODEL_MAX_LENGTH[el.model];
      }
      if (el.model.includes("selector")) {
        return 255;
      }
      return null;
    }
  }
};
</script>

<style scoped>
.header-section {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FormGroupRowLayout.vue